import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { DeleteActionIcon } from 'icons'
import s from './FormItemList.modules.scss'
import { TitleWithCount } from '../TitleWithCount'

export interface FormItem {
  id: number
  text: string
}

export interface FormItemListProps {
  items: FormItem[]
  startIcon: React.ReactNode
  deleteHandler: Function
  title?: string
  containerClassName?: string
}

const FormItemList = (props: FormItemListProps) => {
  const { items, title, startIcon, deleteHandler, containerClassName } = props

  return (
    <Box className={containerClassName}>
      {title && (
        <Box className={s.titleContainer}>
          <TitleWithCount title={title} counter={items.length} />
        </Box>
      )}
      <List dense={true} className={s.list}>
        {items.map(item => (
          <ListItem
            key={item.id}
            secondaryAction={
              <div className={s.deleteContainer} onClick={() => deleteHandler(item.id)}>
                <DeleteActionIcon />
              </div>
            }
            disableGutters
            className={s.listItem}
          >
            <ListItemIcon>{startIcon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default FormItemList
